var _rect, _path, _g, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWebchat = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FF7A33"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1504_1161)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1504_1161",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8H8V24H24V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1504_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 9.61978H12.6666C10.6666 9.61978 9.33331 10.9531 9.33331 12.9531V16.9531C9.33331 18.9531 10.6666 20.2865 12.6666 20.2865H15.3333L18.3 22.2598C18.74 22.5531 19.3333 22.2398 19.3333 21.7065V20.2865C21.3333 20.2865 22.6666 18.9531 22.6666 16.9531V12.9531C22.6666 10.9531 21.3333 9.61978 19.3333 9.61978ZM18.3333 15.4998H13.6666C13.3933 15.4998 13.1666 15.2731 13.1666 14.9998C13.1666 14.7265 13.3933 14.4998 13.6666 14.4998H18.3333C18.6066 14.4998 18.8333 14.7265 18.8333 14.9998C18.8333 15.2731 18.6066 15.4998 18.3333 15.4998Z",
    fill: "#EFF2F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1504_1161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWebchat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/webchat.f836deec.svg";
export { ForwardRef as ReactComponent };